import { render } from "./Consumer.vue?vue&type=template&id=6303f1bd"
import script from "./Consumer.vue?vue&type=script&lang=js"
export * from "./Consumer.vue?vue&type=script&lang=js"
script.render = render

export default script